module.exports = __webpack_public_path__ + "img/emerald-coast-top-angle.a88b82ad.png";